import { Routes, Route, useLocation, useParams } from "react-router-dom";

import styles from "./CreateDocument.module.css";

import TagMapping from "./TagMapping";
// import DocumentForm from "../../components/DashBoard/DocumentForm"
import DocumentLayout from "../../components/LayoutEditor/LayoutDocument"

import { Breadcrumb, ObjectNotEmpty } from "../../Utils/helper";
import DocumentHeader from "../../components/DashBoard/DocumentHeader"
import HeaderTabs from "../../components/DashBoard/HeaderTabs";
import { useEffect, useState } from "react";
import { BASE_URL, GET_DOCUMENT, USER_TOKEN } from "../../Utils/constant";
// import { Loader } from "../../Utils/helper";
import cogoToast from "cogo-toast-react-17-fix";
import Error from "../../components/OnBoard/Error";
import useRefreshToken from "../../Hooks/usegenerateToken";
import API from "../../ApiConfig"
import SlideUpWrapper from "../../components/Transitions/SlideUpWrapper";
import SupportingDocument from "./SupportingDocument";
import IssuerNavigator from "../../components/DashBoard/IssuerNavigator";
const CreateDocument = () => {
  // let access_token = useRefreshToken(BASE_URL+USER_TOKEN)
  let { id } = useParams();
  const [document, setdocument] = useState({})

  const paths = [
    { name: "All Documents", url: "/company/1/" + document.issuer_id + "/Documents" },
    { name: document.master_doc_name, url: '/' }
  ]
  const Tabs = [
    { name: "Tag Mapping", link: "/create/" + id + "/Mapping", img: "/copyoutline.svg", img1: "/copyoutline-1.svg" },
    { name: "Supporting Document", link: "/create/" + id + "/SupportingDocument", img: "/copyoutline.svg", img1: "/copyoutline-1.svg" },
    { name: "Document Layout", link: "/create/" + id + "/Layout", img: "/copyoutline.svg", img1: "/copyoutline-1.svg" }
  ]
  useEffect(() => {
    API.get(GET_DOCUMENT + id)
      .then(data => {
        let res = data.data
        if (res.success === true) {
          setdocument(res.data)
        }
        else {
          setdocument(0)
        }
      })
      .catch(err =>
        cogoToast.error(err.message)
      )
  }, [])
  const headerPos = 2;
  var navindex = 0
  if ((useLocation().pathname).includes('Supporting')) {
    navindex = 1
  }
  if ((useLocation().pathname).includes('Layout')) {
    navindex = 2
  }
  var title = ["Tag Mapping", "Document Design", "Document Layout"]

  // const DocumentHeaderComponent = () => {
  //   if (!ObjectNotEmpty(document)) {
  //     return (
  //       <div className={styles.companyHeader}>
  //         <DocumentHeader user_type="1" />
  //         <HeaderTabs Tabs={Tabs} position={navindex} id={id} type={1} />
  //       </div>
  //     )
  //   }
  //   else {
  //     return (
  //       <div className={styles.companyHeader}>
  //         {/* <DocumentHeader
  //           doc_image={document.document_icon}
  //           doc_name={document.master_doc_name}
  //           id={document.issuer_id}
  //           user_type="1"
  //         />
  //         <HeaderTabs Tabs={Tabs} position={navindex} id={id} type={1} /> */}
  //       </div>
  //     )
  //   }
  // }

  if (document === 0) {
    return <Error Message="No Such Document" />;
  }

  return (
    <SlideUpWrapper direction="slide-left">
      <div className={styles.companyProfile}>
        {/* <DocumentHeaderComponent /> */}
        <main className={styles.frameSupportingText}>
          <section className={styles.h1Parent}>
            {/* <div className={styles.h1}>
              <h2 className={styles.input}>{title[navindex]}</h2>
            </div> */}
            <Routes>
              <Route path="/Mapping" element={<TagMapping id={id} doc_name={document.doc_name}  />} />
              <Route path="/SupportingDocument" element={<SupportingDocument id={id} doc_name={document.doc_name} />} />
              <Route path="/Layout" element={<DocumentLayout id={id} />} />
            </Routes>
          </section>
        </main>
      </div>
    </SlideUpWrapper>
  );
};

export default CreateDocument;
